module.exports = __webpack_public_path__ + "static/media/stump.b84222eb.svg";